<template>
  <div ref="map" class="map map--fullwidth"></div>
</template>

<script>
import gmapsInit from '@/utils/helpers/gmaps';

export default {
  name: 'maps',
  props: {
    height: {
      type: Number,
      default: 180,
    },
    markers: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      markersList: [],
    };
  },
  async mounted() {
    const google = await gmapsInit();

    const geocoder = new google.maps.Geocoder();
    const paris = { lat: 48.8567, lng: 2.3508 };

    const map = new google.maps.Map(this.$refs.map,
      {
        center: paris,
        zoom: 17,
      });
    this.markers.forEach((marker, index) => {
      const address = `${marker.address.street} ${marker.address.postal} ${marker.address.city}`;
      geocoder.geocode({ address }, (results) => {
        if (results && results[0]) {
          if (index === 0) {
            map.setCenter(results[0].geometry.location);
          }
          this.markersList.push(new google.maps.Marker({
            map,
            position: results[0].geometry.location,
            title: marker.title,
          }));
        }
      });
    });
  },
};
</script>

<style scoped lang="scss">
  .map {
    height: 180px;
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    @include breakpoint(desktop){
      height: 100%;
    }

  }
</style>
